<template>
  <DocumentDetail
      title="Bevételek"
      resource-type="INCOME"
  />
</template>

<script>
import DocumentDetail from "@/views/app/cashflow/DocumentDetail.vue";

export default {
  name: "Income",
  components: {
    DocumentDetail
  }
};
</script>
